// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const commentsHistoryConfig = {
    title: 'chart.instagram.comments_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.instagram.comments_history_name',
        paid: 'paid_data',
        organic: 'organic_data',
        avg: 'chart.instagram.comments_history_avg'
    },
    id: 'comments_history',
    color: {
        value: 'yellow',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.facebook.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.instagram.comments_history_tooltip',
    size: SIZE_50,
    isXAxisDate: true,
    adsDataToken: 'chart.instagram.ads_data_tooltip',
    type: 'chart',
    element: LineChart
};
